import type { User, UserLogin } from '../../../types/User';

export const mockedUsers: User[] = [
  {
    id: 1,
    read_news: [],
    created_at: '2023-07-01T10:00:00Z',
    email: 'admin@example.com',
    terms: true,
    info: {
      name: 'Alice Admin',
      phone: '123-456-7890',
      city: 'Sofia',
    },
    invoicing: {
      name: 'Admin Corp',
      eik: '123456789',
      address: '123 Admin Street, Sofia',
      mol: 'Alice A.',
    },
    addresses: {
      ourCourier: {
        name: 'Alice Admin',
        phone: '123-456-7890',
        city: 'Варна',
        address: 'Admin Address, Варна',
        note: 'Leave at the door',
      },
      courierAddress: {
        name: 'Alice Admin',
        phone: '123-456-7890',
        city: 'Plovdiv',
        address: 'Admin Address, Plovdiv',
        note: 'Call before delivery',
        courier: 'ekont',
      },
      courierOffice: {
        name: 'Alice Admin',
        phone: '123-456-7890',
        city: 'Sofia',
        office: 'Office 1',
        note: 'At the reception',
        courier: 'speedy',
      },
    },
    status: 'active',
    access_level: 'Admin',
    tag: 'admin_tag',
  },
  {
    id: 2,
    created_at: '2023-07-02T11:00:00Z',
    email: 'moderator@example.com',
    terms: true,
    info: {
      name: 'Bob Moderator',
      phone: '987-654-3210',
      city: 'Plovdiv',
    },
    invoicing: {
      name: 'Moderator LLC',
      eik: '987654321',
      address: '456 Moderator Avenue, Plovdiv',
      mol: 'Bob M.',
    },
    addresses: {
      ourCourier: {
        name: 'Bob Moderator',
        phone: '987-654-3210',
        city: 'Варна',
        address: 'Moderator Address, Варна',
        note: 'Deliver to security',
      },
      courierAddress: {
        name: 'Bob Moderator',
        phone: '987-654-3210',
        city: 'Burgas',
        address: 'Moderator Address, Burgas',
        note: 'Ring the bell',
        courier: 'speedy',
      },
      courierOffice: {
        name: 'Bob Moderator',
        phone: '987-654-3210',
        city: 'Plovdiv',
        office: 'Office 2',
        note: 'Near the entrance',
        courier: 'ekont',
      },
    },
    status: 'active',
    access_level: 'Moderator',
    tag: 'moderator_tag',
    read_news: []
  },
  {
    id: 3,
    created_at: '2023-07-03T12:00:00Z',
    email: 'user@example.com',
    terms: true,
    info: {
      name: 'Charlie User',
      phone: '555-123-4567',
      city: 'Burgas',
    },
    invoicing: {
      name: 'User Inc.',
      eik: '555123456',
      address: '789 User Road, Burgas',
      mol: 'Charlie U.',
    },
    addresses: {
      ourCourier: {
        name: 'Charlie User',
        phone: '555-123-4567',
        city: 'Варна',
        address: 'User Address, Варна',
        note: 'Front desk',
      },
      courierAddress: {
        name: 'Charlie User',
        phone: '555-123-4567',
        city: 'Sofia',
        address: 'User Address, Sofia',
        note: 'Hand over to reception',
        courier: 'ekont',
      },
      courierOffice: {
        name: 'Charlie User',
        phone: '555-123-4567',
        city: 'Burgas',
        office: 'Office 3',
        note: 'Left side desk',
        courier: 'speedy',
      },
    },
    status: 'inactive',
    access_level: 'User',
    tag: 'user_tag',
    read_news: []
  },
];

export const mockedUserAccess: Record<'admin' | 'moderator' | 'user', UserLogin> = {
  admin: {
    email: 'admin@example.com',
    password: 'admin_password123',
  },
  moderator: {
    email: 'moderator@example.com',
    password: 'moderator_password123',
  },
  user: {
    email: 'user@example.com',
    password: 'user_password123',
  },
};

export const mockedUserLogins: UserLogin[] = Object.values(mockedUserAccess);
